/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetOrders200ResponseOrdersInnerItemsInner
 */
export interface GetOrders200ResponseOrdersInnerItemsInner {
    /**
     * 
     * @type {string}
     * @memberof GetOrders200ResponseOrdersInnerItemsInner
     */
    internalCode: string;
    /**
     * 
     * @type {string}
     * @memberof GetOrders200ResponseOrdersInnerItemsInner
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetOrders200ResponseOrdersInnerItemsInner
     */
    image: string;
    /**
     * 
     * @type {number}
     * @memberof GetOrders200ResponseOrdersInnerItemsInner
     */
    amount: number;
    /**
     * 
     * @type {number}
     * @memberof GetOrders200ResponseOrdersInnerItemsInner
     */
    quantity: number;
}

/**
 * Check if a given object implements the GetOrders200ResponseOrdersInnerItemsInner interface.
 */
export function instanceOfGetOrders200ResponseOrdersInnerItemsInner(value: object): value is GetOrders200ResponseOrdersInnerItemsInner {
    if (!('internalCode' in value) || value['internalCode'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('image' in value) || value['image'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    return true;
}

export function GetOrders200ResponseOrdersInnerItemsInnerFromJSON(json: any): GetOrders200ResponseOrdersInnerItemsInner {
    return GetOrders200ResponseOrdersInnerItemsInnerFromJSONTyped(json, false);
}

export function GetOrders200ResponseOrdersInnerItemsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOrders200ResponseOrdersInnerItemsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'internalCode': json['internalCode'],
        'name': json['name'],
        'image': json['image'],
        'amount': json['amount'],
        'quantity': json['quantity'],
    };
}

export function GetOrders200ResponseOrdersInnerItemsInnerToJSON(json: any): GetOrders200ResponseOrdersInnerItemsInner {
    return GetOrders200ResponseOrdersInnerItemsInnerToJSONTyped(json, false);
}

export function GetOrders200ResponseOrdersInnerItemsInnerToJSONTyped(value?: GetOrders200ResponseOrdersInnerItemsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'internalCode': value['internalCode'],
        'name': value['name'],
        'image': value['image'],
        'amount': value['amount'],
        'quantity': value['quantity'],
    };
}

